import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const RoutinesImpactAnalyze = lazy(() => import('./pages/RoutinesImpactAnalyze'));
const RmsCustomization = lazy(() => import('./pages/RmsCustomization'));

export const checklistsRoutes: RouteObject = {
  path: 'checklists',
  handle: { breadcrumb: 'RMS & VMS Analyze' },
  children: [
    {
      index: true,
      element: <RoutinesImpactAnalyze />,
      handle: { breadcrumb: 'RMS Change Impacts' },
    },
    {
      path: 'rms',
      element: <RmsCustomization />,
      handle: { breadcrumb: 'RMS Customization' },
    },
  ],
};
